import moment from 'moment'

import store from "@/session/Store.js";

let api = {
    store,
    selectLangCallback: async (f) => {
        window.console.log('Esto es necesario porque peta al importar APIPortal desde cualquier componente en components/*.vue.', f);
    },
    getAuthToken() {
        return this.store.state.authToken
    },
    setAuthToken(f) {
        this.store.commit( "setAuthToken", f)
    },
    getUser() {
        return this.store.state.user
    },
    setUser(f) {
        this.store.commit( "setUser", f)
    },
    getComments() {
        return this.store.state.comments
    },
    setComments(f) {
        this.store.commit( "setComments", f)
    },
    getHomeHTML() {
        return this.store.state.homeHTML
    },
    setHomeHTML(f) {
        this.store.commit( "setHomeHTML", f)
    },
    getTeleconfURL() {
        return this.store.state.teleconfURL
    },
    setTeleconfURL(f) {
        this.store.commit( "setTeleconfURL", f)
    },
    getTenant() {
        return this.store.state.tenant
    },
    setTenant(f) {
        this.store.commit( "setTenant", f)
    },
    getQueue() {
        return this.store.state.queue
    },
    setQueue(f) {
        this.store.commit( "setQueue", f)
    },
    setServicePoint(f) {
        this.store.commit( "setServicePoint", f)
    },
    getServicePoint() {
        return this.store.state.servicePoint
    },
    getServiceChannel() {
        return this.store.state.serviceChannel
    },
    setServiceChannel(f) {
        this.store.commit( "setServiceChannel", f)
    },
    getVisitor() {
        return this.store.state.visitor
    },
    setVisitor(f) {
        this.store.commit( "setVisitor", f)
    },
    getTicket() {
        return this.store.state.ticket
    },
    setTicket(f) {
        this.store.commit( "setTicket", f)
    },
    getError() {
        return this.store.state.error
    },
    setError(f) {
        this.store.commit( "setError", f)
    },
    setLanguages(f) {
        this.store.commit( "setLanguages", f)
    },
    async setLanguage(f) {
        window.console.log('setting moment locale>', f.locale)
        moment.locale(f.locale);
        await this.selectLangCallback(f)
        this.store.commit( "setLanguage", f)
    },
    getLanguage() {
        let l = this.store.state.language
        if (l) return l;
        l = window._.filter(this.store.state.languages, {locale: window.vueinstance.$i18n.locale })

        return l.length ? l[0]: null;
    },

    setConfiguration(f) {
        this.store.commit( "setConfiguration", f)
    },
    getConfiguration() {
        return this.store.state.configuration
    },

    getUseSingleQueue() {
        return this.store.state.useSingleQueue
    },
    setUseSingleQueue(f) {
        this.store.commit( "setUseSingleQueue", f)
    }
};

export default api;